"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", "%;\n  height: ", ";\n  background-color: #ccc;\n  display: block;\n  overflow: hidden;\n  margin: 4px;\n\n  &.pui-skeleton--effect-fade {\n    animation: blink 1s linear infinite;\n    animation-direction: alternate;\n  }\n\n  @keyframes blink{\n    0% {opacity: 0.2;}\n    50% {opacity: .5;}\n    100% {opacity: 1;}\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledLineSkeleton = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.width * 100;
}, function (props) {
  return props.height ? props.height : '27px';
});
/**
 * Basic line skeleton
 */


var LineSkeleton = function LineSkeleton(_ref) {
  var className = _ref.className,
      effect = _ref.effect,
      props = _objectWithoutProperties(_ref, ["className", "effect"]);

  return /*#__PURE__*/_react["default"].createElement(StyledLineSkeleton, _extends({}, props, {
    className: (0, _clsx["default"])(className, "pui-skeleton--effect-".concat(effect))
  }));
};

LineSkeleton.propTypes = {
  /**
   * Line width
   */
  width: _propTypes["default"].string,

  /**
   * Line height
   */
  height: _propTypes["default"].string
};
var _default = LineSkeleton;
exports["default"] = _default;